import * as React from 'react';
import { Outlet } from 'umi';
import { FI18n, FUtil } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import FLoadingTip from '@/components/FLoadingTip';

interface I18nReadyWarpperProps {}

function I18nReadyWarpper({}: I18nReadyWarpperProps) {
  const [i18nReady, set$i18nReady, get$i18nReady] = FUtil.Hook.useGetState<boolean>(false);

  AHooks.useMount(() => {
    // console.log('I18nReadyWarpper ********************');
  });

  AHooks.useMount(async () => {
    await FI18n.i18nNext.ready();
    set$i18nReady(true);
  });

  if (i18nReady) {
    return <Outlet />;
  } else {
    return <FLoadingTip height={window.innerHeight} />;
  }
}

export default I18nReadyWarpper;
